import { gql } from '@apollo/client';

const SEND_CONSULTING_REQUEST = gql`
  mutation sendConsultingRequest($input: SendConsultingRequestInput!) {
    sendConsultingRequest(input: $input) {
      isSuccess
      message
    }
  }
`;

export default SEND_CONSULTING_REQUEST;
